module.exports = __webpack_public_path__ + "img/Image from iOS (5) 3.d3885685.png";